<template>
  <div class="wuliu_wrap">
    <div class="title" style="padding-left:10px;">
      {{ progressInfo.kdname }}：{{ wuliudanhao }}
    </div>

    <div class="addressInfo" style="padding-left:10px;padding-bottom:10px;border-bottom:1px dashed #daf3ff;margin-bottom:10px;">
      <p><span>{{ progressInfo.receivername }}</span>&nbsp;<span>{{ progressInfo.receivertel }}</span></p>
      <p>{{ progressInfo.receiveraddress }}</p>
    </div>

    <!-- 永远显示链接 + 时间线，用 v-show 不销毁 DOM → 必显示 -->
    <div style="margin:15px 0;" v-show="isShowUrl">
      <a
        :href="traceUrl"
        target="_blank"
        style="color:#409eff; font-size:16px; font-weight:bold;"
      >
        👉 点击查看官方完整物流信息
      </a>
    </div>

    <el-timeline v-show="!isShowUrl">
      <el-timeline-item
        v-for="(activity, index) in progressInfo.tracelist"
        :key="index"
        :timestamp="activity.time"
      >
        <b>{{ activity.status }}</b>
        <p>{{ activity.description }}</p>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import { wuliuInfo } from '@/api/manage.js'

export default {
  props: ['cartid', 'wuliudanhao'],
  data() {
    return {
      progressInfo: {
        kdname: '',
        receiveraddress: '',
        receivername: '',
        receivertel: '',
        tracelist: [],
        traceurl: ''
      },
      traceUrl: '',
      isShowUrl: false
    }
  },
  mounted() {
    this.getWuliuInfo()
  },
  methods: {
    getWuliuInfo() {
      let self = this
      wuliuInfo({ cartid: self.cartid }).then(res => {
        if (res.status && res.data) {
          // 强制赋值
          self.progressInfo = res.data
          self.traceUrl = res.data.traceurl || ''
          
          // 强制控制显示隐藏 → 绝对生效
          if (self.traceUrl && self.traceUrl.trim() !== '') {
            self.isShowUrl = true
          } else {
            self.isShowUrl = false
          }
          
          // 强制刷新视图（解决弹窗不渲染）
          self.$forceUpdate()
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/wuliu.vue